// Waste & Meals — the module's error reader.
//
// The platform envelope is `{"detail": <payload>}`; this module puts an object
// inside it, so nothing about the shared axios interceptor changes. Every
// message is pre-rendered in BOTH languages by the server, so there is no
// error string to translate on the client.

export function wmError(e) {
    const d = e?.response?.data?.detail;
    if (d && typeof d === "object" && d.code) return d;
    return null;
}

export function wmCode(e) {
    return wmError(e)?.code || null;
}

export function wmMessage(e, lang, fallback) {
    const d = wmError(e);
    if (d) return lang === "ar" ? d.message_ar : d.message_en;
    // A timeout or a dropped connection has no response at all.
    if (e?.code === "ECONNABORTED" || !e?.response) return null;
    const raw = e?.response?.data?.detail;
    if (typeof raw === "string") return raw;
    return fallback || null;
}

/** Per-line errors from `POST /records/bulk` -> { [line_index]: payload } */
export function wmLineErrors(e) {
    const d = wmError(e);
    const out = {};
    for (const err of d?.errors || []) {
        if (typeof err.line_index === "number") out[err.line_index] = err;
    }
    return out;
}

export const WM_TIMEOUT_MS = 15000;
